import { Query } from '../../../../_base/actionBus/Query';
import { Booking } from '../../../../models/bookings/Booking';

export class GetPublicBookings extends Query<Booking[]> {
    constructor(public amenityId: number) {
        super();
    }
}
